// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 13 hooks for backend/academy.

import { useBackend } from '../useBackend'

/** POST /api/academy/cancelAcademyRequest */
export function useCancelAcademyRequest<T = any>() {
  return useBackend<T>('academy/cancelAcademyRequest')
}

/** POST /api/academy/checkAcademySignatures */
export function useCheckAcademySignatures<T = any>() {
  return useBackend<T>('academy/checkAcademySignatures')
}

/** POST /api/academy/createAcademyRequest */
export function useCreateAcademyRequest<T = any>() {
  return useBackend<T>('academy/createAcademyRequest')
}

/** POST /api/academy/getAcademyBoard */
export function useGetAcademyBoard<T = any>() {
  return useBackend<T>('academy/getAcademyBoard')
}

/** POST /api/academy/getAcademyProofUrl */
export function useGetAcademyProofUrl<T = any>() {
  return useBackend<T>('academy/getAcademyProofUrl')
}

/** POST /api/academy/getAcademyRequestDocumentLink */
export function useGetAcademyRequestDocumentLink<T = any>() {
  return useBackend<T>('academy/getAcademyRequestDocumentLink')
}

/** POST /api/academy/getAcademyRequestOptions */
export function useGetAcademyRequestOptions<T = any>() {
  return useBackend<T>('academy/getAcademyRequestOptions')
}

/** POST /api/academy/getAcademyRequestPreview */
export function useGetAcademyRequestPreview<T = any>() {
  return useBackend<T>('academy/getAcademyRequestPreview')
}

/** POST /api/academy/getAcademyRequests */
export function useGetAcademyRequests<T = any>() {
  return useBackend<T>('academy/getAcademyRequests')
}

/** POST /api/academy/markAcademyRequestPaid */
export function useMarkAcademyRequestPaid<T = any>() {
  return useBackend<T>('academy/markAcademyRequestPaid')
}

/** POST /api/academy/moveSponsorshipToLoans */
export function useMoveSponsorshipToLoans<T = any>() {
  return useBackend<T>('academy/moveSponsorshipToLoans')
}

/** POST /api/academy/resendAcademyRequest */
export function useResendAcademyRequest<T = any>() {
  return useBackend<T>('academy/resendAcademyRequest')
}

/** POST /api/academy/setAcademySponsored */
export function useSetAcademySponsored<T = any>() {
  return useBackend<T>('academy/setAcademySponsored')
}
